// Common route configuration - extracted to avoid circular imports
export const commonRouteConfig = {
    index: {
        path: '/',
    },
    login: {
        path: '/login',
    },
    register: {
        path: '/register',
    },
    forgotPassword: {
        path: '/forgot-password',
    },
    resetPassword: {
        path: '/reset-password',
    },
    logout: {
        path: '/logout',
    },
}

// Breadcrumb paths configuration - also exported from here to avoid circular imports
export const noBreadcrumbPaths = [
    '/intakes/intake',
    '/intakes/complete',
    '/people',
    '/companies',
    '/research',
    '/searches',
    '/job',
    '/mappings',
    '/admin',
]
